import { useTranslationImpl, useUnsafeTranslationImpl } from './service';

export const TranslationAdapter = <T>() => {
  return {
    t: useTranslationImpl<T>(),
    unsafeT: useUnsafeTranslationImpl<T>(),
  };
};
